import {isObservable} from 'rxjs';
import {Store} from 'signalstory';
import {StoreConfig} from 'signalstory/lib/store-config';

import {inject, Injectable, Injector, Signal} from '@angular/core';

export const DEFAULT_INDEXED_DB_NAME = 'doccycle-store-db' as const;
export const DEFAULT_INDEXED_DB_SIGNAL_STORE_NAME = 'doccycle-store-signalstore-db' as const;
export const DEFAULT_INDEXED_DB_SIGNAL_STORE_VERSION = 5 as const;

@Injectable({providedIn: 'root'})
export abstract class SignalStoreV0<TState, Actions extends ActionsObject = ActionsObject> extends Store<TState> {
	public readonly injector: Injector = inject(Injector);
	// Store Selectors:
	public abstract readonly SELECTORS$: {[key in `select${Capitalize<string>}`]: Signal<unknown>};
	// Store	Actions:
	public abstract readonly ACTIONS$: Actions;

	protected constructor(config: StoreConfig<TState>) {
		super(config);
	}

	public dispatchAction(fn: this['ACTIONS$'][keyof this['ACTIONS$']], ...args: Parameters<this['ACTIONS$'][keyof this['ACTIONS$']]>): void {
		const result = fn(...args);
		if (isObservable(result)) {
			result.subscribe();
		} else if (result instanceof Promise) {
			result.then();
		} else {
			//	Do nothing
		}
	}

	// ResetableStore Decorator:
	/**
	 * Reset the store to its initial state.
	 */
	abstract reset(): void;
}

/* -------------------------------------------------------------------------------------------------------------- */
export const FeatureStoreNames = {
	CYCLE_SIGN_FEATURE_KEY: 'cycleSign',
	FORM_GROUP_FEATURE_KEY: 'formGroup',
	GLOBAL_SEARCH_FEATURE_KEY: 'globalSearch',
	COMPANY_SETTINGS_FEATURE_KEY: 'companySettings',
	META_TAGS_FEATURE_KEY: 'metaTags',
} as const;

export type FeatureStoreNames = (typeof FeatureStoreNames)[keyof typeof FeatureStoreNames];
/* -------------------------------------------------------------------------------------------------------------- */
export const SignalStoreNames = {
	/* ---------------------------------------------  Feature Stores --------------------------------------------- */
	LIVENESS_VALIDATOR: 'livenessValidator',
} as const;

export type SignalStoreNames = (typeof SignalStoreNames)[keyof typeof SignalStoreNames];
